import Vue from 'vue'
import VueRouter from 'vue-router'
import { guardSuperAdmin } from '@/services/superAdmin'

Vue.use(VueRouter)

function lazyLoad(view) {
  return () => import(`@/views/${view}.vue`)
}

const routes = [
  {
    path: '/admin/super-admin',
    component: lazyLoad('SuperAdmin/Base'),
    meta: { superAdmin: true },
    children: [
      { path: '', redirect: { name: 'SuperAdminRevenue' } },
      { path: 'revenue', name: 'SuperAdminRevenue', component: lazyLoad('SuperAdmin/RevenueCalendar') },
      { path: 'members', name: 'SuperAdminMembers', component: lazyLoad('SuperAdmin/Members') },
      { path: '*', component: lazyLoad('SuperAdmin/NotFound') }
    ]
  },
  {
    path: '/',
    name: 'Login',
    component: lazyLoad("LoginPage")
  },
  {
    path: '/set_password',
    name: 'SetPassword',
    component: lazyLoad("SetPassword")
  },
  {
    path: '/admin',
    component: lazyLoad("Admin/Base"),
    children: [
      // {
      //   path: '',
      //   redirect: 'adminer'
      // },
      {
        path: '',
        name: 'AdminDashboard',
        // component: lazyLoad("Admin/RecentTransaction")
        component: lazyLoad("Admin/Dashboard")
      },
      {
        path: 'recent_transaction',
        name: 'AdminRecentTransaction',
        component: lazyLoad("Admin/RecentTransaction")
      },
      {
        path: 'adminer',
        name: 'AdminAdminer',
        component: lazyLoad("Admin/Adminer")
      },
      {
        path: 'partner',
        name: 'AdminPartner',
        component: lazyLoad("Admin/Partner")
      },
      {
        path: 'member',
        name: 'AdminMember',
        component: lazyLoad("Admin/Member")
      },
      {
        path: 'station',
        name: 'AdminStation',
        component: lazyLoad("Admin/Station")
      },
      {
        path: 'control',
        name: 'AdminControl',
        component: lazyLoad("Admin/Control")
      },
      {
        path: 'device',
        name: 'AdminDevice',
        component: lazyLoad("Admin/Device")
      },
      {
        path: 'member_log',
        name: 'AdminMemberLog',
        component: lazyLoad("Admin/MemberLog")
      },
      {
        path: 'partner_log',
        name: 'AdminPartnerLog',
        component: lazyLoad("Admin/PartnerLog")
      },
      {
        path: 'admin_log',
        name: 'AdminAdminLog',
        component: lazyLoad("Admin/AdminLog")
      },
      {
        path: 'notification_log',
        name: 'AdminNotificationLog',
        component: lazyLoad("Admin/NotificationLog")
      },
      {
        path: 'information',
        name: 'AdminInformation',
        component: lazyLoad("Admin/Information")
      },
      {
        path: 'password',
        name: 'AdminPassword',
        component: lazyLoad("Admin/Password")
      },
      {
        path: 'mornitor',
        name: 'AdminMornitor',
        component: lazyLoad("Admin/Mornitor")
      },
      {
        path: 'expiring_devices',
        name: 'AdminExpiringDevices',
        component: lazyLoad("Admin/ExpiringDevices")
      },
      {
        path: 'increase_expiration_logs',
        name: 'AdminIncreaseExpirationLogs',
        component: lazyLoad("Admin/IncreaseExpirationLogs")
      },
      // ....................................
      {
        path: 'partner/:id',
        name: 'AdminPartnerID',
        component: lazyLoad("Admin/PartnerID")
      },
      {
        path: 'member/:id',
        name: 'AdminMemberID',
        component: lazyLoad("Admin/MemberID")
      },
      {
        path: 'member/:id/revenue',
        name: 'AdminMemberRevenueCalendar',
        component: lazyLoad("Admin/RevenueCalendar")
      },
      {
        path: 'station/:id',
        name: 'AdminStationID',
        component: lazyLoad("Admin/StationID")
      },
      {
        path: 'control/:id',
        name: 'AdminControlID',
        component: lazyLoad("Admin/ControlID")
      },
      {
        path: 'device/:id',
        name: 'AdminDeviceID',
        component: lazyLoad("Admin/DeviceID")
      },
      // ....................................
      {
        path: 'block_mac',
        name: 'AdminBlockMac',
        component: lazyLoad("Admin/BlockMac")
      },
      {
        path: 'export_transaction',
        name: 'AdminExportTransaction',
        component: lazyLoad("Admin/ExportTransaction")
      },
      {
        path: 'export_report',
        name: 'AdminExportReport',
        component: lazyLoad("Admin/ExportReport")
      },
    ]
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(guardSuperAdmin)

export default router
